import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axios/axiosBaseQuery';

/**
 * Placeholder for the auto-generated web api client code.
 * webAPi.ts file in this folder is auto-generated, and shouldn't be manually edited!
 */
export const emptyWebApi = createApi({
  baseQuery: axiosBaseQuery(),
  reducerPath: 'webApi',
  endpoints: () => ({}),
  tagTypes: ['Minors', 'Minor', 'Customer', 'EnrolmentPayments', 'Certificates', 'MinorCertificates'],
});
